import { FalconConfig } from '../types';

export const normalizeConfig = (config: FalconConfig) => {
  if (config?.__type === 'aem-headless') {
    const transformedDealerList = config?.config?.fields?.listOfDealers?.map((str: string) =>
      JSON.parse(str.replace(/'/g, '"')),
    );
    const positions = (({
      vehicleTypePosition,
      listOfDealersPosition,
      bodyTypePosition,
      makeTypesPosition,
      modelFamilyPosition,
      modelYearPosition,
      trimLinePosition,
      pricePosition,
      mileagePosition,
      exteriorColorPosition,
      interiorColorPosition,
      fuelTypePosition,
      driveTrainPosition,
      wheelSizePosition,
      gearboxPosition,
      powerPosition,
    }) => ({
      vehicleTypePosition,
      listOfDealersPosition,
      bodyTypePosition,
      makeTypesPosition,
      modelFamilyPosition,
      modelYearPosition,
      trimLinePosition,
      pricePosition,
      mileagePosition,
      exteriorColorPosition,
      interiorColorPosition,
      fuelTypePosition,
      driveTrainPosition,
      wheelSizePosition,
      gearboxPosition,
      powerPosition,
    }))(config.config.fields);

    const panelStates = (({
      bodyTypePanelState,
      modelFamilyPanelState,
      trimLinePanelState,
      exteriorColorPanelState,
      interiorColorPanelState,
      fuelTypePanelState,
      driveTrainPanelState,
      wheelSizePanelState,
      gearboxPanelState,
      mileagePanelState,
      pricePanelState,
      powerPanelState,
      modelYearPanelState,
      makeTypePanelState,
      vehicleTypePanelState,
    }) => ({
      bodyTypePanelState,
      modelFamilyPanelState,
      trimLinePanelState,
      exteriorColorPanelState,
      interiorColorPanelState,
      fuelTypePanelState,
      driveTrainPanelState,
      wheelSizePanelState,
      gearboxPanelState,
      mileagePanelState,
      pricePanelState,
      powerPanelState,
      modelYearPanelState,
      makeTypePanelState,
      vehicleTypePanelState,
    }))(config?.config?.fields);

    const newConfig = {
      ...config.config.fields,
      filterPositions: positions,
      filterPanelStates: panelStates,
      listOfDealers: transformedDealerList,
    };
    // (!) map Falcon config to you previous config structure
    return newConfig;
  }

  return config;
};
